module.exports = __webpack_public_path__ + "static/media/newspaper.b0270f42.svg";